export default __webpack_public_path__ + "static/media/order-bell-greenIcon.773258cc.svg";